import React, { useState } from 'react';
import classes from './InitialSectionRoad.module.css';
import { Icons } from '@Assets/SvgIcons';
import { useAppDispatch } from '@Store/hooks';
import { postNewTaskVisibleID } from '@Store/feature/playBookDetailSlice';
import CustomIconButton from '../CustomIconButton/CustomIconButton';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ImportPlaybook from '@/pages/Playbook/components/ImportPlaybook';

interface IProps {
  currentSectionId: string;
  setInitialTaskVisible: (newTaskVisible: boolean) => void;
  setExpand: (expand: boolean) => void;
  setIsEmpty: (trigger: boolean) => void;
  setnewTaskVisible: (trigger: boolean) => void;
}

export default function InitialSectionRoad({
  currentSectionId,
  setInitialTaskVisible,
  setExpand,
  setIsEmpty,
  setnewTaskVisible,
}: IProps) {
  const dispatch = useAppDispatch();
  const [showImportModal, setshowImportModal] = useState(false);
  return (
    <div
      style={{
        background: 'rgba(224, 223, 230, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <div style={{ color: '#383463', fontWeight: 600, fontSize: 16 }}>
        Get started with your first task and start your journey of being like
        flash!
      </div>
      <div
        style={{
          color: '#383463',
          fontWeight: 500,
          fontSize: 13,
          marginTop: 10,
        }}
      >
        Click the button below to create new or import your exisiting tasks and
        Voila. Easy isn’t it!
      </div>
      <div className={classes.IconAligment}>
        <div className={classes.iconWithText}>
          <Icons.AddTask />
          <div className={classes.message}>Add a task</div>
        </div>
        <Icons.BoardArrow />
        <div className={classes.iconWithText}>
          <Icons.SetDueDate />
          <div className={classes.message}>Set due date</div>
        </div>
        <Icons.BoardArrow />
        <div className={classes.iconWithText}>
          <Icons.AssingTeammate />
          <div className={classes.message}>Assign to a teammate</div>
        </div>
      </div>
      <div className={classes.ActionButtons}>
        <CustomIconButton
          title="Add New Task"
          className={classes.addNewTask}
          spanClassName={'pl-10'}
          icon={<Icons.Add color="#ffffff" />}
          clickHandler={() => {
            setExpand(true);
            dispatch(postNewTaskVisibleID(currentSectionId));
            setnewTaskVisible(true);
            setIsEmpty(true);
            setInitialTaskVisible(true);
          }}
        />
        <CustomIconButton
          title="Import Your Task"
          className={classes.importYourTask}
          spanClassName={'pl-10'}
          icon={<FileUploadOutlinedIcon style={{ color: '#7F77D9' }} />}
          clickHandler={() => {
            setshowImportModal(true);
          }}
        />
      </div>
      <ImportPlaybook
        open={showImportModal}
        handleClose={() => setshowImportModal(false)}
      ></ImportPlaybook>
    </div>
  );
}
